<template>
	<div
		class="dashboard__chat-ui__content__message text--primary d-flex"
		:class="[
			{
				'dashboard__chat-ui__content__message--receiver':
					i.from !== chat.nickname
			},
			{
				'dashboard__chat-ui__content__message--sender':
					i.from === chat.nickname
			}
		]"
	>
		<profile-picture
			:text="i.from"
			:img="i.profilePicture"
			class="dashboard__chat-ui__content__message__avatar"
		></profile-picture>
		<div
			class="dashboard__chat-ui__content__message__text-time d-flex flex-column "
		>
			<p class="dashboard__chat-ui__content__message__from">
				<span>
					{{ i.from }}
				</span>
			</p>
			<p
				v-html="i.text"
				class="dashboard__chat-ui__content__message__text"
			></p>
			<p
				class="dashboard__chat-ui__content__message__time m-0 text--secondary"
			>
				{{ i.createdAt | formatDate }}
				<i
					v-if="i % 2 === 0"
					class="fal fa-check-double ml-2 read-icon"
				></i>
			</p>
		</div>
	</div>
</template>

<script>
import formatDate from "../../utils/date"
import ProfilePicture from "./ProfilePicture.vue"
export default {
	props: {
		i: Object,
		chat: Object
	},
	filters: {
		formatDate
	},
	components: {
		ProfilePicture
	}
}
</script>
